const getNextAdminAction = (array, key) => {
  const filtered = array.filter((item) => item.id === key);
  return filtered.length > 0
    ? filtered[0].name
    : 'Nothing to do';
};

export default getNextAdminAction;
